import script from "./searchInput.vue?vue&type=script&setup=true&lang=js"
export * from "./searchInput.vue?vue&type=script&setup=true&lang=js"

import "./searchInput.vue?vue&type=style&index=0&id=2625b4d4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2625b4d4"]])

export default __exports__